export const state = () => ({
  uploadPercentage: {
    FileSTR: 0,
    FileIDI: 0,
    FileSIP: 0,
    FileProfessionalOrganization: 0,
    SpecialistCertificate: 0,
    FileCertificate: 0,
    AdditionalFiles: []
  },
  clinicInvitation: false,
  isProfileComplete: false,
  isShowModal: false,
  additionalLength: 0
})

export const getters = {
  getStatusProfile: (state) => {
    return state.isProfileComplete
  },
  getStatusModal: (state) => {
    return state.isShowModal
  },
  getAdditionalLength: (state) => {
    return state.additionalLength
  },
  getAdditionalFiles: (state) => {
    return state.uploadPercentage.AdditionalFiles
  }
}

export const mutations = {
  SET_PROGRESS: (state, data) => {
    if (typeof data.id === 'number' && data.key === 'AdditionalFiles') {
      state.uploadPercentage.AdditionalFiles[data.id].progress = data.progress
    } else {
      state.uploadPercentage[`${data.key}`] = data.progress
    }
  },
  SET_ADDITIONAL: (state, data) => {
    try {
      state.uploadPercentage.AdditionalFiles.push(data)
    } catch (error) {
      throw new Error(error)
    }
  },
  DELETE_ADDITIONAL: (state, data) => {
    const old = state.uploadPercentage.AdditionalFiles
    old.splice(data, 1)
    state.uploadPercentage.AdditionalFiles = old
  },
  SET_ADDITIONAL_INDEX: (state, data) => {
    state.uploadPercentage.AdditionalFiles = data
  },
  SET_ADDITIONAL_LENGTH: (state, data) => {
    state.additionalLength = data
  },
  SET_ADDITIONAL_PROGRESS: (state, data) => {
    state.uploadPercentage.AdditionalFiles[data.id].progress = data.progress
  },
  SET_CLINIC_INVITATION: (state, data) => {
    state.clinicInvitation = data
  },
  SET_STATUS_PROFILE: (state, data) => {
    state.isProfileComplete = data
  },
  SET_STATUS_MODAL: (state, data) => {
    state.isShowModal = data
  }
}

export const actions = {
  uploadDocument ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      if (`${Object.keys(data.file)[0]}` === 'AdditionalFiles') {
        formData.append('AdditionalFiles', Object.values(data.file)[0][0])
      } else {
        formData.append(`${Object.keys(data.file)[0]}`, Object.values(data.file)[0])
      }

      this.$api.post('doctor/document/upload', formData, {
        onUploadProgress (progressEvent) {
          const object = {
            progress: parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
            key: `${Object.keys(data.file)[0]}`,
            id: data.id
          }
          commit('SET_PROGRESS', object)
        }
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateExistingAdditionalFiles ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('AdditionalFiles', data.AdditionalFiles)
      this.$api.post('doctor/document/upload', formData, {
        onUploadProgress (progressEvent) {
          const object = {
            progress: parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
            key: 'AdditionalFiles',
            id: data.ID
          }
          commit('SET_ADDITIONAL_PROGRESS', object)
        }
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateDocumentColumn ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/profile/document/edit', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateShowModal ({ commit }) {
    commit('SET_STATUS_MODAL', true)
  },
  getDataTelegram () {
    return new Promise((resolve, reject) => {
      this.$api.get('/doctor/telegram', {
        headers: {
          WebVersion: '1'
        }
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
